export default __webpack_public_path__ + "static/media/Sprayer.cd67c7f6.jpg";